import io from 'socket.io-client'

export const socketURL = window.socketURL || 'http://localhost:8080';
export const socket = io.connect(socketURL, {withCredentials: true});

export const msgSocketURL = window.msgSocketURL || 'http://localhost:8081'
export const msgSocket = null;
//export const msgSocket = io.connect(msgSocketURL);

var connectCallBack = (msg) => {};
var connectErrCallBack = (e) => {};

export const setConnectCallBack = (cb) => {
  connectCallBack = cb;
}

export const setConnectErrCallBack = (cb) => {
  connectErrCallBack = cb;
}

socket.on('connect', () => {
  console.log('SocketIO: connecting');
});

socket.on('reconnect', () => {
  console.log('SocketIO: reconnecting');
});

socket.on('connect_response', (msg) => {
  console.log('SocketIO: connect response: ', msg)
  connectCallBack(msg);  
});

socket.on('disconnect', () => {
  console.log('SocketIO: disconnecting.');
});

socket.on('connect_error', (err) => {
  // We get a 401 unauthorized if we are logged out
  // We get a ERR_CONNECTION_REFUSED if the server is down...
  console.log('SocketIO: connect error', JSON.stringify(err));
  connectErrCallBack(err);
});

// {'type': 'TransportError', 'description': 401}  <-- this is the not authorized err object
// {'type': 'TransportError', 'description': 0}  <-- this is the connection refused server down error



